import React ,{ useEffect } from 'react';
import { FaWhatsapp, FaInstagram, FaEnvelope } from 'react-icons/fa';
import './about.css';
import { Link } from 'react-router-dom';
const About = () => {

        useEffect(() => {
          window.scrollTo(0, 0); // Scroll to the top of the page when component mounts
        }, []);
        
  return (
    <div className="app-container">
         <Link to="/">
          <button className="comic-button">Back</button>
        </Link>
      <header className="profile-header">
        <h1>Akram Ali Faridi</h1>
        <p>Full Stack & Machine Learning Developer</p>
        <p>2 Years of Experience | Available for Freelancing</p>
      </header>
      <footer className="social-footer">
        <a href="https://wa.me/+919060237575" target="_blank" rel="noopener noreferrer">
          <FaWhatsapp />
        </a>
        <a href="https://www.instagram.com/shoyev._4" target="_blank" rel="noopener noreferrer">
          <FaInstagram />
        </a>
        <a href="mailto:faridiakram41@gmail.com">
          <FaEnvelope />
        </a>
        <button className="button1">
  <a href="/CV.pdf" download="Akram_Ali_Faridi_Resume.pdf" className="download-button">
    Resume
  </a>
  </button>



      </footer>
      <section className="personal-details">
        <p><strong>Nationality:</strong> Indian</p>
        <p><strong>Phone</strong>+91 9060237575</p>
        <p><strong>Languages Known:</strong> English, Hindi, Urdu, Tamil, Arabic</p>
       
      </section>
      
      <section className="experience-section">
        <h2>Experience(2 Years)</h2>
        <p>I am a full-stack developer skilled in React.js, React Native, Flask, website and application development, database manipulation with MySQL and Firebase, and machine learning.</p>
      </section>
      
      <section className="education-section">
        <h2>Education</h2>
        <div className="card">
          <h3>10th Grade</h3>
          <p>School: [Holy mission high school]</p>
          <p>Address: [Samastipur , Bihar , India 848101]</p>
        </div>
        <div className="card">
          <h3>12th Grade</h3>
          <p>School: [Springer Public School]</p>
          <p>Address: [Paryagraj,Uttar pradesh, India 211001]</p>
        </div>
        <div className="card">
          <h3>NDA Traning</h3>
          <p>Institution: Major Khalshi Classes</p>
          <p>Address: [Allahabad , U.P, India 211004 ]</p>
        </div>
        <div className="card">
          <h3>B.Tech</h3>
          <p>Anna University</p>
          <p>Address: [Tamil Nadu , India 623501 ]</p>
        </div>
        <div className="card">
          <h3>M.Tech</h3>
          <p>Presidency University</p>
          <p>Address: [Banglore, Karnatak , India 560089 ]</p>
        </div>
      </section>
      
      

    
    </div>
  );
};

export default About;
